export default __webpack_public_path__ + "static/bg-tax--mobile-b64c4cbb54c7a62474c9f9b839631b06.jpg";